import { render, staticRenderFns } from "./TournamentLayout.vue?vue&type=template&id=9a4eeab4&"
import script from "./TournamentLayout.vue?vue&type=script&lang=js&"
export * from "./TournamentLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports